import usePageMeta from "utils/usePageMeta";
import MKBox from "components/MKBox";

import SubPageLayout from "reusables/layouts/SubPageLayout";

import Commercial_Section1 from "./sections/Commercial_Section1";

function CommercialCleaning() {
  usePageMeta({
    title: "Commercial Cleaning Services Ireland | Spechs",
    description:
      "Commercial cleaning for retail, hospitality, and large-scale properties across Ireland.",
    canonical: "https://www.spechs.ie/cleaning/commercial/",
  });
  return (
    <SubPageLayout title="Commercial Cleaning">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Commercial_Section1 />
      </MKBox>
    </SubPageLayout>
  );
}

export default CommercialCleaning;
